import { Flex, LayoutBox, TextButton, IconV2, StyledBoxV2 } from '@bamboohr/fabric';
import {
       Message,
} from '@bamboohr/utils/lib/message';

type StateWHMigrationMessageProps = {
	onMigrateFormClick: () => void;
	/** The two-letter shorthand of a US State */
	stateAbbreviation: string;
}

const stateMessage = new Map<string, string>([
	['IA', $.__('Need to make changes? [Update using the new Iowa State form.]')],
	['LA', $.__('The Louisiana State Tax Withholding Form has changed. [Make changes with the updated form fields.]')],
]);

export function StateWHMigrationMessage({
	onMigrateFormClick,
	stateAbbreviation
}: StateWHMigrationMessageProps) {

	const handleMigrationFormClick = () => {
		onMigrateFormClick()
	}

	return (
		stateAbbreviation 
		? <Flex margin='-4px 0 12px'>
			<LayoutBox marginRight="4px">
				<IconV2
					color='neutral-extra-strong'
					name='circle-info-regular'
					size={12}
				/>
			</LayoutBox>
			<Message
				link={(text) => (
					<StyledBoxV2 margin="0 0 0 4px">
						<TextButton inline={true} onClick={handleMigrationFormClick} type='button' >
							{text}
						</TextButton>
					</StyledBoxV2>
				)}
				text={ stateMessage.get(stateAbbreviation) }
			/>
		</Flex>
		: null
	);
}